import type { ProductReviewFragment, VoteOnReviewMutation } from '#graphql-operations'
import { defineStore } from 'pinia'

export const useProductReviewsStore = defineStore('productReviews', () => {
  const route = useRoute()
  const queryCache = useQueryCache()
  const { markAsVoted, hasVoted } = useProductReviewVoteTracker()
  const { refetch: refetchReviews } = useReviewsQuery()

  const voteOnReview = async (review: ProductReviewFragment, vote: boolean) => {
    const { data } = await useGraphqlMutation('voteOnReview', {
      id: review.id,
      vote,
    }) as { data: VoteOnReviewMutation }

    if (data?.voteOnReview) {
      const productId = route.params.id as string
      if (productId === review.product.id) {
        queryCache.setQueryData(
          ['productReviewsFeed', productId],
          (oldData: { items: Map<string, ProductReviewFragment>, totalItems: number, skip: number | null } | undefined) => {
            if (!oldData) {
              const newMap = new Map<string, ProductReviewFragment>()
              newMap.set(review.id.toString(), data.voteOnReview as ProductReviewFragment)

              return {
                items: newMap,
                totalItems: 1,
                skip: null,
              }
            }

            // If oldData exists, create a new object with copied values
            const newItems = new Map(oldData.items)
            newItems.set(review.id.toString(), data.voteOnReview as ProductReviewFragment)

            return {
              items: newItems,
              totalItems: oldData.totalItems,
              skip: oldData.skip,
            }
          },
        )
      }
      else {
        await refetchReviews()
      }
    }

    return data?.voteOnReview
  }

  return {
    markAsVoted,
    hasVoted,
    voteOnReview,
  }
})
